import React, { useState, useEffect } from 'react'
import Header from '../component/header';
import "../assets/css/portfolio.css";
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import configModule from '../../config.js';
import { Toaster, toast } from "react-hot-toast";
import Pagination from "@mui/material/Pagination";

function PortFolio() {
  const navigate = useNavigate();
  const [usersData, setUsersData] = useState(null);
  const [cardData, setCardData] = useState(null);
  const [portfolioData, setPortfolioData] = useState(null);
  const config = configModule.config();
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;

  const getPortfolioData = async () => {

    try {
      const response = await axios.get(
        `${config.apiBaseUrl}/get-portfoliodata/${usersData?.id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const card = response.data?.card[0];
      const data = response.data?.data;
      setCardData(card);
      setPortfolioData(data);
      setPage(1);

    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Something went wrong";

      toast.error(message);
    }
  };

  useEffect(() => {
    if (usersData?.id) {
      getPortfolioData();
    }
  }, [usersData]);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      const decoded = jwtDecode(token);
      setUsersData(decoded);
    }
  }, []);

  const formatIndianCurrency = (value) => {
    if (value === null || value === undefined || value === '') return '₹0';

    const num = Number(value);
    if (isNaN(num)) return '₹0';

    const absNum = Math.abs(num);
    const sign = num < 0 ? '-' : '';

    let formatted;
    if (absNum >= 10000000) {
      // Crore
      formatted = (absNum / 10000000).toFixed(absNum % 10000000 === 0 ? 0 : 2) + 'Cr';
    } else if (absNum >= 100000) {
      // Lakh
      formatted = (absNum / 100000).toFixed(absNum % 100000 === 0 ? 0 : 2) + 'L';
    } else if (absNum >= 1000) {
      // Thousand
      formatted = (absNum / 1000).toFixed(absNum % 1000 === 0 ? 0 : 2) + 'K';
    } else {
      formatted = absNum.toString();
    }

    return `₹${sign}${formatted}`;
  };

  const formatReturnMonth = (returnMonth) => {
    if (!returnMonth) return "";

    return new Date(`${returnMonth}-01`).toLocaleString("en-US", {
      month: "short",
      year: "numeric",
    });
  };

  const formatPaymentDate = (date) => {
    if (!date) return "";

    const d = new Date(date);

    const day = String(d.getUTCDate()).padStart(2, "0");
    const month = String(d.getUTCMonth() + 1).padStart(2, "0");
    const year = d.getUTCFullYear();

    return `${day}/${month}/${year}`;
  };

  const totalPages = Math.ceil((portfolioData?.length || 0) / rowsPerPage);

  const paginatedPortfolioData = portfolioData?.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  ) || [];

  return (
    <div className='dashboardmain-st'>
      <Header pageName="My Portfolio" />
      <div className="body-dashboard">
        <div className="page-header">
          <div className="page-eyebrow">Investments</div>
          <div className="page-title">My Portfolio</div>
          <div className="page-subtitle">Complete view of all your property investments</div>
        </div>

        <div className="lxp-stats" style={{ gridTemplateColumns: "repeat(3,1fr)" }}>
          <div className="lxp-stat-card">
            <div className="lxp-stat-label">Total Invested</div>
            <div className="lxp-stat-value">{formatIndianCurrency(cardData?.total_invesment) || 0}</div>
            <div className="lxp-stat-sub"><span className="lxp-stat-sub green">3 Property</span></div>
          </div>
          <div className="lxp-stat-card">
            <div className="lxp-stat-label">Current Portfolio Value</div>
            <div className="lxp-stat-value">{formatIndianCurrency(cardData?.total_invesment) || 0}</div>
            <div className="lxp-stat-sub"><span className="lxp-stat-sub green">+18%</span></div>
          </div>
          <div className="lxp-stat-card">
            <div className="lxp-stat-label">Combined Monthly Return</div>
            <div className="lxp-stat-value">{formatIndianCurrency(cardData?.combin_month_ret) || 0}</div>
            <div className="lxp-stat-sub">Paid monthly</div>
          </div>
        </div>

        <div className="chart-card">
          <div className="chart-table-st">
            <div className="lxp-prop-hero">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: "14px" }}>
                <div>
                  <div className="lxp-prop-hero-name">Phase I </div>
                  <span className='lxp-prop-hero-loc'>(18% Returns Per Annum)</span>
                </div><span className="lxp-pill pill-green">Active</span>
              </div>
              <div className="lxp-prop-stats">
                <div className='d-center flex-column'>
                  <div className="lxp-prop-stat-label">Invested</div>
                  <div className="lxp-prop-stat-val">{formatIndianCurrency(cardData?.total_invesment) || 0}</div>
                </div>
                <div className='d-center flex-column'>
                  <div className="lxp-prop-stat-label">Current Value</div>
                  <div className="lxp-prop-stat-val" style={{ color: "#7ee0a8" }}>{formatIndianCurrency(cardData?.total_invesment) || 0}</div>
                </div>
                <div className='d-center flex-column'>
                  <div className="lxp-prop-stat-label">Monthly Return</div>
                  <div className="lxp-prop-stat-val">
                    {formatIndianCurrency(
                      (cardData?.combin_month_ret || 0) / (cardData?.paid_month || 1)
                    ) || 0}
                  </div>
                </div>
                <div className='d-center flex-column'>
                  <div className="lxp-prop-stat-label">Invesment Duration</div>
                  <div className="lxp-prop-stat-val">{cardData?.paid_month}</div>
                </div>
              </div>
            </div>


            <div className='bott-detportst'>
              <button className="btn-st btn-ghost-st" onClick={() => navigate("/property-details")} >View Property Details →</button>
            </div>

            <div style={{ background: "#fff", overflow: "auto" }}>
              <div className="card-header-st" style={{ minWidth: "752px" }}>
                <div>
                  <div className="card-title-st">Returns history</div>
                </div>
              </div>

              <div style={{ minWidth: "752px" }}>
                <div className="d-flex w-100">
                  <div className="w-20 d-center comcolldbtab-st hdcoldbtab-st">Month</div>
                  <div className="w-20 d-center comcolldbtab-st hdcoldbtab-st">Amount</div>
                  <div className="w-20 d-center comcolldbtab-st hdcoldbtab-st">Paid On</div>
                  <div className="w-20 d-center comcolldbtab-st hdcoldbtab-st">Mode</div>
                  <div className="w-20 d-center comcolldbtab-st hdcoldbtab-st">Status</div>
                </div>
                <div className='main-bodytab-st'>
                  {paginatedPortfolioData?.map((item, index) => (
                    <div className="d-flex w-100" key={index}>
                      <div className="w-20 d-center comcolldbtab-st bdycoldbtab-st">{formatReturnMonth(item?.return_month)}</div>
                      <div className="w-20 d-center comcolldbtab-st bdycoldbtab-st">₹ {item?.amount}</div>
                      <div className="w-20 d-center comcolldbtab-st bdycoldbtab-st">{formatPaymentDate(item?.payment_date)}</div>
                      <div className="w-20 d-center comcolldbtab-st bdycoldbtab-st">{item?.payment_mode}</div>
                      <div className="w-20 d-center comcolldbtab-st bdycoldbtab-st">
                        <span
                          className={
                            item.status === "Paid"
                              ? "pill pill-active"
                              : item.status === "Pending"
                                ? "pill pill-pending"
                                : "pill pill-delayed"
                          }
                        >
                          {item.status}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div
                className="d-flex justify-content-between align-items-center totalinfooter-st " style={{ minWidth: "752px" }}
              >
                <p
                  className="mb-0 hdcoldbtab-st ps-2 p-0"
                  style={{
                    background: "transparent",
                    border: "none",
                  }}
                >
                  Showing{" "}
                  {portfolioData?.length === 0
                    ? 0
                    : (page - 1) * rowsPerPage + 1}
                  {" - "}
                  {Math.min(
                    page * rowsPerPage,
                    portfolioData?.length || 0
                  )}
                  {" of "}
                  {portfolioData?.length || 0} records
                </p>

                <Pagination
                  count={totalPages}
                  page={page}
                  onChange={(event, value) => setPage(value)}
                  color="primary"
                  shape="rounded"
                  showFirstButton
                  showLastButton
                  sx={{
                    "& .MuiPaginationItem-root": {
                      color: "#1e386e",
                      borderColor: "#1e386e",
                    },

                    "& .MuiPaginationItem-root:hover": {
                      backgroundColor: "#1e386e20",
                    },

                    "& .Mui-selected": {
                      backgroundColor: "#1e386e !important",
                      color: "#fff",
                      borderColor: "#1e386e",
                    },

                    "& .MuiPaginationItem-icon": {
                      color: "#1e386e",
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: "#0a1628",
            color: "#fff",
            borderRadius: "10px",
            padding: "14px 18px",
          },
          success: {
            iconTheme: {
              primary: "#22c55e",
              secondary: "#fff",
            },
          },
          error: {
            iconTheme: {
              primary: "#ef4444",
              secondary: "#fff",
            },
          },
        }}
      />
    </div>
  )
}

export default PortFolio;
